<template>
    <div class="role-wrapper">
        <div class="role-operate-bar">
            <RoundButton @btnClick="addRoleHandle" :text="addRoleLabel" />
        </div>
        <div class="role-content">
            <Table class="role-table-list" :config="tableConfig" :dataset="roleData" @pageChange="pageChange" />
        </div>
        <div class="page-control">
            <PageControl :total="roleTotal" :curPage="curPage" :lengthRank="pageLengthRank" :pageLength="10" @pageChange="pageChange" />
        </div>
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import Table from "@/views/zhiji/bComponents/table/Table";
import PageControl from "@/views/zhiji/bComponents/pageController/PageControl";
import RoleEditModal from "./RoleEditModal";

import { roleTableConfig } from "../../personConfig.js";

export default {
    name: "RoleManage",
    components: {
        RoundButton,
        Table,
        PageControl
    },
    data() {
        return {
            curPage: 1,
            curPageLen: 10,
            pageLengthRank: 10
        };
    },
    computed: {
        tableConfig() {
            return roleTableConfig();
        },
        addRoleLabel() {
            return this.$t("zhiji.personnel.addBtnLabel");
        },
        roleData() {
            return this.getStorePorp("roleData");
        },
        roleTotal() {
            return this.getStorePorp("roleListTotal");
        }
    },
    watch: {
        addRoleLabel() {
            this.$store.commit("zhiji/clearGroupOption");
            this.$store.commit("zhiji/clearRoleOption");
            this.getRoleListData();
        }
    },
    mounted() {
        this.getRoleListData();
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.personnelManage[propName];
        },
        addRoleHandle() {
            this.$store.dispatch("zhiji/showModal", {
                type: RoleEditModal,
                data: ""
            });
        },
        getRoleListData() {
            this.$store.dispatch("zhiji/queryRoleList", {
                page: this.curPage,
                size: this.curPageLen
            });
        },
        pageChange(data) {
            if (this.curPageLen == data.pageLength && this.curPage == data.curPage) {
                return;
            }
            this.curPageLen = data.pageLength;
            this.curPage = data.curPage;

            this.getRoleListData();
        }
    }
};
</script>

<style lang="less" scoped>
.role-wrapper {
    margin: 16px 24px 16px 16px;
    padding: 0 24px 24px;
    background: #fff;
    border: 1px solid #d9e4ef;
    border-radius: 4px;

    .role-operate-bar {
        padding: 16px 24px 16px 0;
        background: #fff;
        border-bottom: 1px solid #d8e4f0;
        margin-bottom: 16px;
    }

    .role-content {
        border-width: 0 1px 1px;
        border-style: solid;
        border-color: #e3ecf5;
        box-sizing: border-box;
    }

    .page-control {
        width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px 0;
        text-align: center;
        color: rgba(65, 71, 94, 0.7);
    }
}
</style>
